import React, { useState, useEffect, useMemo, useContext } from 'react';
import {BrandContext} from "@context/BrandContext";
import axios from "@common/axios";
import TableAntD from "@common/TableAntD";
import Button, {BUTTON_TYPE} from "@common/Button";
import MathJaxHTMLContent from "@common/MathJaxHTMLContent";
import {Row} from "antd";
import ArrowLeftIcon from "@common/icons/ArrowLeftIcon";

const TestAssignmentQuestionResults = (props) => {
    const {testAssignmentId, handleBack} = props;
    const brandConfig = useContext(BrandContext),
        [resultsTableData, setResultsTableData] = useState(),
        [isLoading, setLoading] = useState(true),
        [testAssignmentName, setTestAssignmentName] = useState('');

    const questionResultsColumns = [
        {
            key:'questionId',
            title:'Question',
            dataIndex:'question',
            render:(value)=>{return(<><h4>Question {(value.idx+1)}.</h4><MathJaxHTMLContent disableInputs={true} html={value.instructions}/></>)}
        },
        {
            key:'correct',
            title:'Correct',
            dataIndex:'correct',
            width:100
        },
        {
            key:'incorrect',
            title:'Incorrect',
            dataIndex:'incorrect',
            width:100
        },
        {
            key:'notAttempted',
            title:'Not Attempted',
            dataIndex:'notAttempted',
            align:'center',
            width:100
        }];

    if(brandConfig.testAssignmentShowCommonIncorrect){
        questionResultsColumns.splice(3,0,{
            key:'commonIncorrect',
            title:'Common Incorrect',
            dataIndex:'commonIncorrect',
            align:'center',
            width:100
        });
    }

    if(brandConfig.testAssignmentShowQuestionLevel){
        questionResultsColumns.push({
            key:'level',
            title:'Level',
            dataIndex:'level',
            align:'center',
            width:100
        });
    }

    useEffect(()=>{
        axios.get('/web/ui/test/teacher/testAssignment/questionResults', {params: {testAssignmentId:testAssignmentId}})
            .then((response)=>{
                adaptTestDataForTable(response.data.test);
            }).catch((error)=>{
                console.error('Error retrieving question results for assignment: ',error);
        }).finally(()=>{
            setLoading(false);
        })
    },[])

    const adaptTestDataForTable = (test)=>{
        const tableData = [];
        test.testQuestionBeans.forEach((question,idx)=>{
            let commonIncorrect;
            if(question.studentsCorrect > 0 && ((question.studentsCorrect + question.studentsNotAnswered) === question.studentsAssigned)){
                commonIncorrect = 'N/A'
            }else if(question.hasOwnProperty('mostCommonIncorrect')){
                commonIncorrect = `${question.mostCommonIncorrect} (${question.mostCommonIncorrectCount})`;
            }else{
                commonIncorrect = 'N/A';
            }

            tableData.push({questionId:question.questionId,
                question: {instructions:question.instructions,idx:idx},
                correct:question.percentCorrect+'%',
                incorrect:question.percentIncorrect+'%',
                commonIncorrect:commonIncorrect,
                notAttempted:question.percentNotAnswered,
                level:question.testDiffLevel
            });
        })
        setTestAssignmentName(test.name);
        setResultsTableData(tableData);
    }

    return (<>
        <Row justify={'space-between'} ><h3>{testAssignmentName}</h3><Button type={BUTTON_TYPE.TEXT} onClick={handleBack}><ArrowLeftIcon/> Back to Assigned</Button></Row>
        <TableAntD rowKey={'questionId'} scroll={{y:Math.max(400,window.innerHeight-325)}} dynamicWidth={true} columnData={questionResultsColumns}
                   dataSource={resultsTableData} noDataMessage={'No data for assignment.'} loading={isLoading}/>
    </>)
};

export default TestAssignmentQuestionResults;